module.exports = __webpack_public_path__ + "img/gb-wls.dbfba263.png";